import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c7f98f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_ArticleCategorySet = _resolveComponent("ArticleCategorySet")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: 16 }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { span: 16 }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            title: "文章分类",
            style: {"margin-bottom":"16px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_table, {
                dataSource: _ctx.list,
                columns: _ctx.columns,
                bordered: "",
                pagination: false,
                "row-key": (record)=>record.id
              }, {
                bodyCell: _withCtx(({ column, text, record }) => [
                  (column.key === 'image')
                    ? (_openBlock(), _createBlock(_component_a_image, {
                        key: 0,
                        width: 50,
                        height: 50,
                        src: record.image
                      }, null, 8, ["src"]))
                    : _createCommentVNode("", true),
                  (column.key === 'is_show')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(text == 1 ? '显示' : '隐藏'), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (column.key === 'action')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createVNode(_component_a_button, {
                          size: "small",
                          type: "primary",
                          danger: record.is_show == 0,
                          onClick: ($event: any) => (_ctx.setShow(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(record.is_show == 0 ? '显示' : '隐藏') + "分类 ", 1)
                          ]),
                          _: 2
                        }, 1032, ["danger", "onClick"]),
                        _createVNode(_component_a_divider, { type: "vertical" }),
                        _createVNode(_component_a_button, {
                          size: "small",
                          onClick: ($event: any) => (_ctx.setEdit(record))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_1
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_a_divider, { type: "vertical" }),
                        _createVNode(_component_a_popconfirm, {
                          title: "是否删除该分类?",
                          onConfirm: ($event: any) => (_ctx.onDel(record))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, { size: "small" }, {
                              default: _withCtx(() => [
                                _hoisted_2
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["onConfirm"])
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["dataSource", "columns", "row-key"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, { span: 8 }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            title: "设置分类",
            bordered: false,
            class: "add_content"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ArticleCategorySet, {
                "edit-item": _ctx.editItem,
                reset: _ctx.reset
              }, null, 8, ["edit-item", "reset"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}